<template>

    <trax-ui-top-box :background-image="registration.program.meta.background" :custom-class="customClass"
        :title1="registration.program.name" :description="registration.program.description"
        :button-icon="buttonIcon" :button-name="buttonName" :button-handler="buttonHandler" 
        :button2-icon="competenciesIcon" :button2-name="competenciesName" :button2-href="competenciesHref" 
        :link1="group" :link2="date"
        :warning="stateWarning">
    </trax-ui-top-box>

</template>

<script>
    export default {

        props: {
            id: { default: 'enac-atpl-dashboard-registration-phases' },
            groupLink: { default: false },
            dashboardButton: { default: false },
            exportButton: { default: false },
            topButtons: { default: false },
            loadStates: { default: false },
        },

        data() {
            return {
                app_url: app_url,
                user: user,
                lang: lang,
                registration: data.registration,
                learner: data.learner,
                program_dashboard_routes: data.program_dashboard_routes,
                state: null,
                bus: this.$bus,
            }
        },

        created() {
            this.bus.$on(this.id+'-registration-state', this.setRegistrationState);

            if (this.learner && this.loadStates) {
                this.getStates();
            }
        },

        computed: {

            stateWarning() {
                return this.state && this.state.cancelled
                    ? 'This training has been terminated!'
                    : ''
            },

            endpointStates() {
                return this.learner
                    ?this.app_url+'polaris/api/front/dashboard/registrations/'+this.registration.id+'/learners/'+this.learner.id
                    : ''
            },

            customClass() {
                return this.topButtons ? 'mb-1' : '';
            },

            group() {
                var link = {value: this.registration.cohort.name, icon: 'people'};
                var routes = this.program_dashboard_routes;
                var href = routes[this.registration.program.type]+'/registration/'+this.registration.id;
                if (this.collectiveDashboardPermission && this.groupLink) link.href = href;
                return link;
            },

            date() {
                if (!this.registration.start_date) return null;
                return {value: moment(this.registration.start_date).format('DD MMM YYYY'), icon: 'event'};
            },

            collectiveDashboardPermission() {
                return this.user.admin || this.user.permissions['dashboard.read-all'] || this.user.permissions['dashboard.read-mine-locations']
                         || this.user.permissions['dashboard.read-mine-collaborators'] || this.user.permissions['dashboard.write-all']
                          || this.user.permissions['dashboard.write-mine-locations'] || this.user.permissions['registration.manage'];
            },

            buttonIcon() {
                if (this.dashboardButton) return 'bar_chart';
                return 'get_app';
            },

            buttonName() {
                if (this.dashboardButton) return this.lang.polaris.dashboard.dashboard;
                return this.lang.polaris.dashboard.export;
            },

            buttonHandler() {
                if (this.dashboardButton) return this.dashboardHandler;
                if (this.exportButton && this.exportAccessPermission) return this.exportHandler;
            },

            exportAccessPermission() {
                return this.user.admin
                    || this.user.permissions['export.access-registration']
            },

            competenciesIcon() {
                if (this.dashboardButton) {
                    return null
                }
                if (this.learner) {
                    return 'playlist_add_check';
                }
                return null;
            },

            competenciesName() {
                if (this.dashboardButton) {
                    return null
                }
                if (this.learner) {
                    return this.lang.polaris.dashboard.skills_progress;
                }
                return null;
            },

            competenciesHref() {
                if (this.dashboardButton) {
                    return null
                }
                if (this.learner) {
                    return this.app_url + 'polaris/ui/atpl-dashboard/registration/' + this.registration.id
                        + '/learner/' + this.learner.id
                        + '/skills-progress';
                }
                return null
            },
        },

        methods: {
        
            getStates() {
                var that = this;
                axios.get(this.endpointStates)
                    .then(function (response) {
                        that.setRegistrationState(response.data.data.registration);
                        that.bus.$emit(that.id+'-states', response.data.data);
                    })
                    .catch(function (error) {
                    });
            },

            setRegistrationState(data) {
                this.state = data
            },

            baseUrl() {
                var routes = this.program_dashboard_routes;
                var href = routes[this.registration.program.type]+'/registration/'+this.registration.id;
                if (this.learner) {
                    href += '/learner/'+this.learner.id;
                }
                return href;
            },

            dashboardHandler() {
                window.location = this.baseUrl();
            },

            exportHandler() {
                window.location = this.baseUrl() + '/export';
            },
        }

    }
</script>
